export default function Selection({ value, onChange, config }) {
  return (
    <div style={{ marginTop: "10px" }}>
      {config.options.map((opt) => (
        <button
          key={opt}
          onClick={() => onChange(opt)}
          style={{
            marginRight: "10px",
            padding: "10px 16px",
            fontSize: "16px",
            background: value === opt ? "#007bff" : "#eee",
            color: value === opt ? "white" : "black",
            border: "1px solid #ccc",
            borderRadius: "6px"
          }}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
